export var UserPreferencesDateFormatEnum;
(function (UserPreferencesDateFormatEnum) {
    UserPreferencesDateFormatEnum["Localized"] = "localized";
    UserPreferencesDateFormatEnum["ShortLocalized"] = "shortLocalized";
})(UserPreferencesDateFormatEnum || (UserPreferencesDateFormatEnum = {}));
export const dateFormats = {
    [UserPreferencesDateFormatEnum.Localized]: {
        format: (value, regionCode) => new Intl.DateTimeFormat(regionCode, { day: "numeric", month: "short", timeZone: "UTC", year: "numeric" }).format(value)
    },
    [UserPreferencesDateFormatEnum.ShortLocalized]: {
        format: (value, regionCode) => new Intl.DateTimeFormat(regionCode, { timeZone: "UTC" }).format(value)
    }
};
